module.exports = "/_next/static/images/Hero@2x-c6470dbbdcd3f5886aa926588f728593.png";